import { BaseController } from '../../base/controller';
import { FeedbackModel } from './feedback.model';

export class FeedbackController extends BaseController {
  constructor($scope, controllerService, feedbackService) {
    'ngInject';
    super({
      $scope,
      controllerService,
      feedbackService,
    });
  }

  $onInit() {
    this.submitted = false;

    this.model = new FeedbackModel({
      orderId: this.appCache.get('orderId')
    });

    // Watch and store feedback in cache
    this.$scope.$watch('vm.model', (value) => this.feedbackService.storeFeedback(value), true);
  }

  sendFeedback() {
    this.feedbackService
      .sendFeedback(this.model)
      .then(() => this.sendFeedbackDone(this.model));

    this.submitted = true;
  }

  sendFeedbackDone(feedback) {
    // Track event for feedback
    this.feedbackService.trackFeedback(feedback, true);
  }
}



// WEBPACK FOOTER //
// ./src/app/common/ui/feedback/feedback.controller.js